import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
  addDays,
} from "../../../utils";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import * as DriverSupportActions from "../../../store/actions/DriverSupport";
import * as UserActions from "../../../store/actions/User";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import styles from "../../../constants/assets/variables";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const MAX_DAYS = {
  INSTANT_TIP: 89,
  RIDER_WEEKLY_PAYOUT: 89,
  INSTANT_PAYOUT: 89,
  RIDER_WEEKLY_TIP: 89,
  INSTANT_TIP_WITHDRAW: 89,
};

const toDateString = (date) => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};

const getInitialState = () => {
  return {
    driver_id: "",
    payout_type: "RIDER_WEEKLY_PAYOUT",
    start_date: toDateString(
      new Date(Date.now() - MAX_DAYS["RIDER_WEEKLY_PAYOUT"] * 24 * 3600 * 1000)
    ),
    end_date: toDateString(new Date(Date.now())),
  };
};

const RiderPayoutsModal = (props) => {
  const {
    handleClose,
    activeFilters,
    filterFields,
    getRiderPayouts,
    resetPayoutStore,
    setStatus,
  } = props;
  const [initialState, setInitialState] = useState(getInitialState());
  const [currentDate, setCurrentDate] = useState();
  const filterTypes = [
    "INSTANT_TIP",
    "RIDER_WEEKLY_PAYOUT",
    "INSTANT_PAYOUT",
    "RIDER_WEEKLY_TIP",
    "INSTANT_TIP_WITHDRAW",
  ];

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(
      body,
      Object.keys(initialState)
    );
    if (validationState !== "validated") {
      hasNoErrors = false;

      setStatus({
        type: "error",
        message: "Driver ID, Date Range and Payout Type are mandatory",
      });
    }
    if (body["start_date"] && body["end_date"]) {
      let endDate = new Date(body["end_date"]);
      let startDate = new Date(body["start_date"]);
      if (startDate > endDate) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message: "Start date should come before end date",
        });
      } else {
        let maxPossibleDate = addDays(
          body["start_date"],
          1 * MAX_DAYS[body["payout_type"]]
        );
        if (endDate > maxPossibleDate) {
          hasNoErrors = false;
          setStatus({
            type: "error",
            message:
              "Maximum range of " +
              (MAX_DAYS[body["payout_type"]] + 1) +
              " days allowed, please modify dates",
          });
        }
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key] + "";
      }
    }

    getRiderPayouts(filters).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetPayoutStore();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;

    if (key == "payout_type") {
      let endDate = new Date(Date.parse(values["end_date"] + "T00:00:00"));
      values["start_date"] = toDateString(
        new Date(endDate - MAX_DAYS["INSTANT_TIP"] * 24 * 3600 * 1000)
      );
    }

    setInitialState(values);
  };

  useEffect(() => {
    // set max date
    setCurrentDate(new Date().toISOString().substring(0, 10));
    //set the initial state of form in modal
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading="Rider Payouts Filter"
      handleClose={handleClearFilters}
      id="riderPayoutFilterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="riderPayoutFormClearBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="riderPayoutFormSubmitBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.driver_id}
          onChange={(e) => handleChange("driver_id", e)}
          id="sushi-input"
          data-testId="DriverId"
          label="Driver ID"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          autoFocus={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Date"
          type="date"
          value={initialState.start_date ? initialState.start_date : "  "}
          onChange={(e) => handleChange("start_date", e)}
          fullWidth={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          label="End Date"
          type="date"
          value={initialState.end_date ? initialState.end_date : "  "}
          onChange={(e) => handleChange("end_date", e)}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
        <PaginatedReactDropdown
          options={filterTypes}
          handleChange={handleChange}
          label="Start Date"
          placeholder="Payout Type"
          keyToChange="payout_type"
          showCross={true}
          showPagination={false}
          value={initialState.payout_type}
          id="payoutTypeDropdown"
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { DriverSupport } = state;
  return {
    activeFilters: DriverSupport.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetPayoutStore: () => dispatch(DriverSupportActions.resetState({})),
    getRiderPayouts: bindActionCreators(
      DriverSupportActions.getRiderPayouts,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiderPayoutsModal);
